module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "overflow-hidden elevation-0"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "450"
    },
    model: {
      value: (_vm.isModalEditarEstado),
      callback: function($$v) {
        _vm.isModalEditarEstado = $$v
      },
      expression: "isModalEditarEstado"
    }
  }, [_c('v-card', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v(_vm._s(_vm.indexEstadoSeleccionado ? 'Editar estado' : 'Nuevo estado'))])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-12"
  }, [_vm._v("Los cambios que se realicen afectaràn en todo las secciones usadas (filtros, procesos node-cron, listas y notificaciones por email)")]), _c('div', {
    staticClass: "pa-4"
  }, [(_vm.indexEstadoSeleccionado) ? _c('v-text-field', {
    ref: "codigoModal",
    staticClass: "mb-6",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Codigo estado  ",
      "disabled": "disabled"
    },
    model: {
      value: (_vm.estadoEditar.codigo),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "codigo", $$v)
      },
      expression: "estadoEditar.codigo "
    }
  }) : _vm._e(), _c('v-text-field', {
    ref: "tituloModal",
    staticClass: "mb-6",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Nombre estado  "
    },
    model: {
      value: (_vm.estadoEditar.descripcion),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "descripcion", $$v)
      },
      expression: "estadoEditar.descripcion"
    }
  }), _c('v-text-field', {
    ref: "accionModal",
    staticClass: "mb-6",
    attrs: {
      "hide-details": "hide-details",
      "dense": "dense",
      "label": "Accion  "
    },
    model: {
      value: (_vm.estadoEditar.accion),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "accion", $$v)
      },
      expression: "estadoEditar.accion"
    }
  }), _c('v-select', {
    attrs: {
      "loading": _vm.isLoadingEtapas,
      "hide-details": "hide-details",
      "items": _vm.etapasEstados,
      "label": "Etapa del estado",
      "dense": "",
      "item-text": "descripcion",
      "item-value": "id"
    },
    model: {
      value: (_vm.estadoEditar.etapa),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "etapa", $$v)
      },
      expression: "estadoEditar.etapa"
    }
  }), _c('v-checkbox', {
    staticClass: "mb-4",
    attrs: {
      "color": "primary",
      "hide-details": "hide-details",
      "label": "Este estado cierra el ticket"
    },
    model: {
      value: (_vm.estadoEditar.cerrado),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "cerrado", $$v)
      },
      expression: "estadoEditar.cerrado"
    }
  }), (_vm.estadoEditar.icono) ? _c('v-card', {
    staticClass: "my-1"
  }, [_c('v-img', {
    staticClass: "white--text align-end",
    attrs: {
      "gradient": "to bottom, rgba(0,0,0,.1),#161f2b85",
      "src": _vm.estadoEditar.icono,
      "max-height": "150",
      "content": "content"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-spacer'), _c('small', {
    staticClass: "px-4 py-2 font-size-11 text-muted"
  }, [_vm._v(_vm._s(_vm.estadoEditar.icono))])], 1)])], 1) : _vm._e(), _c('v-file-input', {
    staticClass: "mt-2",
    attrs: {
      "color": "primary",
      "prepend-icon": "",
      "label": _vm.indexEstadoSeleccionado ? 'Seleccionar para cambiar el icono' : 'Seleccionar para agregar icono',
      "placeholder": "Seleccione el archivo",
      "outlined": "",
      "hide-details": "hide-details",
      "show-size": 1000
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var index = ref.index;
        var text = ref.text;

        return [_c('v-chip', {
          attrs: {
            "color": "primary",
            "dark": "",
            "label": "",
            "small": ""
          }
        }, [_vm._v(_vm._s(text))])]
      }
    }]),
    model: {
      value: (_vm.estadoEditar.iconoCambiar),
      callback: function($$v) {
        _vm.$set(_vm.estadoEditar, "iconoCambiar", $$v)
      },
      expression: "estadoEditar.iconoCambiar"
    }
  })], 1)], 1), _c('v-card-actions', {
    staticClass: "mt-3"
  }, [_c('v-spacer'), _c('v-btn', {
    staticClass: "mr-1",
    attrs: {
      "color": "ligth",
      "small": "small"
    },
    on: {
      "click": _vm.closeDialogEditar
    }
  }, [_vm._v("cancelar")]), _c('v-btn', {
    attrs: {
      "color": "success",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarEstado()
      }
    }
  }, [_vm._v(_vm._s(_vm.indexEstadoSeleccionado ? 'Guardar cambios' : 'Generar estado'))])], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "font-weight-700"
  }, [_vm._v("Estados")])]), _c('v-card-subtitle', {
    staticClass: "font-size-12 pb-1"
  }, [_vm._v("Administrador de estados")])], 1), _c('v-btn', {
    staticClass: "ma-5 mr-3",
    attrs: {
      "color": "primary",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.fetch('garantia')
      }
    }
  }, [_c('v-icon', [_vm._v("sync")])], 1), _c('v-btn', {
    staticClass: "mt-5 mr-3",
    attrs: {
      "color": "success",
      "small": "small",
      "fab": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDialogEditar({}, '')
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _c('v-card-title', {
    staticClass: "pt-0"
  }, [_c('v-select', {
    attrs: {
      "hide-details": "hide-details",
      "items": _vm.listadoTiposEstado,
      "label": "Seleccionar ",
      "item-value": "code",
      "item-text": "name",
      "dense": "",
      "solo": ""
    },
    on: {
      "change": function($event) {
        return _vm.fetch()
      }
    },
    model: {
      value: (_vm.tipoEstado),
      callback: function($$v) {
        _vm.tipoEstado = $$v
      },
      expression: "tipoEstado"
    }
  })], 1), _c('v-sheet', {
    staticClass: "overflow-y-auto"
  }, [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "height": "calc(100vh - 298px)"
    }
  }, [_c('lista-draggable', {
    attrs: {
      "options": {
        handle: '.handle'
      },
      "ghost-class": "ghost",
      "chosen-class": "chosen",
      "drag-class": "drag"
    },
    model: {
      value: (_vm.estados),
      callback: function($$v) {
        _vm.estados = $$v
      },
      expression: "estados"
    }
  }, _vm._l((_vm.estados), function(item, i) {
    return _c('v-list', {
      key: i,
      staticClass: "pa-0",
      attrs: {
        "nav": "",
        "dense": ""
      }
    }, [_c('v-list-item', {
      staticClass: "mx-1"
    }, [_c('v-list-item-content', {
      staticClass: "py-0"
    }, [_c('v-list-item-title', [_c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "flex-1"
    }, [_c('span', {
      staticClass: "font-weight-700"
    }, [_vm._v(_vm._s(item.orden) + "   -")]), _c('span', {
      staticClass: "font-size-12"
    }, [_vm._v("  " + _vm._s(item.descripcion) + " (" + _vm._s(item.codigo) + ")")])]), (item.cerrado) ? _c('v-chip', {
      attrs: {
        "label": "label",
        "color": "background"
      }
    }, [_vm._v("Cierra el ticket")]) : _vm._e()], 1)])], 1), _c('v-list-item-icon', {
      staticClass: "handle"
    }, [_c('v-btn', {
      staticClass: "mx-2",
      attrs: {
        "fab": "",
        "dark": "",
        "x-small": "",
        "color": "info"
      },
      on: {
        "click": function($event) {
          return _vm.openDialogEditar(item, i)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("edit")])], 1)], 1), _c('v-list-item-icon', {
      staticClass: "handle"
    }, [_c('v-icon', {
      attrs: {
        "color": "background",
        "size": "30"
      }
    }, [_vm._v("drag_indicator")])], 1)], 1), _c('v-divider')], 1)
  }), 1)], 1)], 1), _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-text', {
    staticClass: "pa-3"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [(!_vm.isMovil) ? _c('small', {
    staticClass: "text-muted font-size-11"
  }, [_vm._v("Mostrando " + _vm._s(_vm.estados.length) + " estados")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "block": _vm.isMovil,
      "color": "success",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchReordenarEstados()
      }
    }
  }, [_vm._v("Reordenar estados")])], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38dfe84a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_administrador_estados.vue
// module id = 492
// module chunks = 1